import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  columnVisibilityModel: {
    __check__ : true,
    key: true,
    title: true,
    actions: true,
    type: false,
    priority: false,
    labels: false,    
    status: false,
    generated_by_user: false,
    created_at: false,
    updated_at: false,
    updated_by_user: false,
    last_executed_date: false,
    last_executed_by: false,
    estimated_duration: false,
    module_path: false
  },
};

const columnVisibilitySlice = createSlice({
  name: 'columnVisibility',
  initialState,
  reducers: {
    updateColumnVisibility(state, action) {
      const { columnName, visibility } = action.payload;
      state.columnVisibilityModel[columnName] = visibility;
    },
    setInitialColumnVisibility(state) {
      state.columnVisibilityModel = { ...initialState.columnVisibilityModel };
    },
  },
});

export const { 
    updateColumnVisibility, 
    setInitialColumnVisibility 
} = columnVisibilitySlice.actions;

export default columnVisibilitySlice.reducer;
